/** @format */

import { IChain } from '@shared/data-access/interfaces';

export class MetaCanonical {
	private static readonly metaCanonicalOld = 'https://www.goinggoing.com';
	private static readonly metaCanonical = 'https://www.goinggoinggone.com';

	public static getMetaCanonical(switchToOldMetaCanonical: boolean): string {
		return switchToOldMetaCanonical ? this.metaCanonicalOld : this.metaCanonical;
	}
}

export const chain: IChain = {
	aemData: {
		title: 'Read More',
		subText: 'Latest From Field Guide'
	},
	authStrategy: 'cookie',
	bopisFlag: true,
	bopisLocationDefault: -1,
	cartUrlParameters:
		'?calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-3&calculationUsageId=-7&updatePrices=1&doConfigurationValidation=Y&catalogId=12301&orderId=.&langId=-1&storeId=15108',
	checkoutUrlBase: 'SinglePageCheckout',
	checkoutUrlParameters:
		'?calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-3&calculationUsageId=-7&updatePrices=1&doConfigurationValidation=Y&catalogId=12301&orderId=.&langId=-1&storeId=15108',
	checkoutConfirmationUrlParameters: 'catalogId=12301&langId=-1&storeId=15108',
	catalogIdCollections: '12301',
	catalogIdContent: '12301',
	catalogIdSales: '12301',
	chainIdentifier: 'GoingGoingGone',
	chainIdentifierAbbr: 'g3',
	chainMarketingIdentifierAbbr: 'g3',
	chainIdentifierCookie: '171',
	chainIdentifierCookieAOS: '172',
	chainInitial: 'D',
	chainName: 'Going Going Gone',
	chainCartImage: false,
	chainCartUrl: '/OrderItemDisplay',
	chainBopisIcon: 'DSGBopis.svg',
	chatUrl: 'https://g3cep.custhelp.com/app/chat/chat_launch',
	holidayOfferCode: 'EM1219DBP3X',
	isaFlag: true,
	logoSVG: 'g3_logo.svg',
	masterCatalogId: '10001',
	metaCanonical: MetaCanonical.getMetaCanonical(false),
	metaCanonicalHost: 'g3',
	metaDescription:
		`Shop activewear as versatile as you. Explore men's apparel designed with premium fabrics and superior functionality for running, training, commuting, and everything in between.`,
	metaTitle: 'Going Going Gone',
	myAccountUrlLoggedIn: '/MyAccount/AccountSummary',
	myAccountUrlAuthListSignIn: '/MyAccount/Lists',
	myAccountUrlLoggedOut: '/LogonForm',
	nestjsProductAPIVersion: 'v6',
	priceStringIndicator: 'dickssportinggoods',
	productAPIVersion: 'v5',
	proTipsFlag: true,
	qAndAFlag: false,
	rewardsAccountName: 'ScoreCard',
	rewardsAccountImage: 'scoreCard.svg',
	searchDex: {
		includeType: {
			meta: 'm',
			body: 'b',
			footer: 'f'
		},
		pageType: {
			category: 'c',
			product: 'p'
		}
	},
	serviceIdentifier: 'goinggoinggone',
	serviceIdentifierAbbr: 'g3',
	sessionCamIdentifier: 'RES-PDP-G3',
	storeId: '15108',
	userRegistrationFormUrl:
		'/UserRegistrationForm?new=Y&catalogId=12301&myAcctMain=1&langId=-1&storeId=15108',
	footerData: {
		social: {
			youtube: 'https://www.youtube.com/channel/UCWi7Sk6dvhx8m_8Vz3v7aXQ',
			twitter: 'https://twitter.com/g3',
			facebook: 'https://www.facebook.com/g3',
			pinterest: 'https://www.pinterest.com/g3/',
			instagram: 'https://www.instagram.com/g3/',
			tiktok: 'https://www.tiktok.com/@goinggoinggone'
		},
		oracleChat: 'https://g3cep.custhelp.com/app/chat/chat_launch',
		copyright: `&copy; ${new Date().getFullYear()} DICK'S Sporting Goods`
	},
	feedbackSurveyId: '28495',
	sizeChartSurveyId: '',
	crossChainBopisPartners: ['dsg'],
	crossChainLogoSVG: 'g3_logo.svg',
	cartTitle: 'Cart',
	vhHeader: '171',
	auth0: {
		enabled: true
	},
	chainFooterUrls: {
		returns: {
			text: 'Returns',
			link: '/s/return-policy'
		},
		shippingRates: null,
		productAvailability: null,
		promoExclusions: null,
		contactCustomerService: null,
		privacyPolicy: {
			text: 'Privacy Policy',
			link: '/s/privacy-policy'
		},
		termsOfUse: {
			text: 'Terms of Use',
			link: '/s/terms-of-use'
		},
		californiaDisclosures: {
			text: 'California Disclosures',
			link: '/s/california-disclosures'
		},
		doNotSellMyInfoCAResidentsOnly: {
			text: 'Your Privacy Choices',
			link: '/s/donotsell'
		},
		accessibilityPolicy: {
			text: 'Accessibility Policy',
			link: '/s/accessibility-policy'
		}
	},
	shippingIcon: 'g3Truck.svg',
	shippingInfoIcon: 'info',
	apiVersion: 2,
	seoIdentifier: 'goinggoinggone',
	rewards: {
		image: 'scoreCard.svg',
		programName: 'ScoreCard'
	},
	xChannel: '',
	supportNumber: '',
	simpleHeaderLogoUrl: ''
};
